const { 
    update_button_visibility,
    clear_error,
    render_verify_error,
    register_verify_error_rederer,
    default_error_rederer
} = require('./page_transition.js');

const {
    checkbox_not_checked
} = require('./form_check_helper');

const nunjucks = require('nunjucks');

// ベリファイエラーレンダラーの追加
register_verify_error_rederer("verify-f26c7ede-1caf-46ac-81e1-ae851164c7fa",default_error_rederer);


const page1_verify=(application_context)=>{
    let DOM_check_accept_term;

    application_context.ary_verify_error ??= [];

    // check1
    DOM_check_accept_term = document.querySelector(`[data-page="1"] [name="accept_term"]`);
    if(DOM_check_accept_term === null) {
        // 内部エラー時もfalseを返す
        return false;
    }
    if(checkbox_not_checked(DOM_check_accept_term)){
        application_context.ary_verify_error.push({
            code:"verify-f26c7ede-1caf-46ac-81e1-ae851164c7fa",
            data:{
                field_name:"accept_term",
                description:nunjucks.renderString(`チェックを入れてください`,{})
            }
        });
    }

    return (application_context.ary_verify_error.length === 0);    
}

module.exports.page1_next = (application_context)=>{

    // 次に進むタイミングでベリファイエラーをリセットする。
    application_context.ary_verify_error.length=0;
    clear_error({page:1});

    if(page1_verify(application_context)){
        let page;

        window.splide_instance.go(">");

        page = window.splide_instance.index;
        application_context.page = page;
        
        update_button_visibility(application_context);
    } else {
        for(let blob_verify_error of application_context.ary_verify_error){
            render_verify_error(blob_verify_error);
        }
    }
}

